var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomLeft"}},[_c('div',{staticClass:"bg-color-black"},[_c('div',{staticClass:"d-flex pt-2 pl-2"},[_c('span',{staticStyle:{"color":"#5cd9e8"}},[_c('icon',{attrs:{"name":"chart-bar"}})],1),_vm._m(0)]),_c('div',[_c('BottomLeftChart')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"fs-xl text mx-2"},[_vm._v("数据统计图")])])
}]

export { render, staticRenderFns }